var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.data.tier &&
    _vm.data.tier.image.resourceUri &&
    _vm.data.tier.image.resourceUri.length > 0
  )?_c('div',{staticClass:"profile-badge-wrapper",class:_vm.className},[_c('img',{staticClass:"profile-badge-image",attrs:{"src":_vm.data.tier.image.resourceUri,"alt":"badge-image"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }